import React from "react";

export interface HeadingProps {
  title: string;
  subtitle: string;
}

const Heading = ({ title, subtitle }: HeadingProps) => {
  return (
    <div className="w-full">
      <div className="text-lg font-medium text-aqua">{subtitle}</div>
      <div className="mt-2 text-5xl font-bold leading-none">{title}</div>
    </div>
  );
};

export default Heading;
